export const iconFontAwesomeMapsCircleInfo = (
	<i className="fa-solid fa-circle-info"></i>
);
